export default __webpack_public_path__ + "static/media/loginScreenImage.6ce67fda.svg";